import React from 'react';

interface WaitingImpatientlyIconProps {
  size?: number; // Size of the entire component (circle + icon)
  iconColor?: string;
  backgroundColor?: string;
  strokeWidth?: number;
}

export const WaitingImpatientlyIcon = ({ 
  size = 40, 
  iconColor = 'white',
  backgroundColor = '#F79009',
  strokeWidth = 1.33333 
}: WaitingImpatientlyIconProps) => {
  // Icon SVG should be the same size as container (fills it)
  
  return (
    <div 
      style={{ 
        width: size,
        height: size,
        borderRadius: '50%',
        backgroundColor: backgroundColor,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path 
          d="M13.3333 5.3335C13.3333 5.3335 13.8995 5.41438 16.2426 7.75752C18.5858 10.1007 18.5858 13.8997 16.2426 16.2428C15.4125 17.073 14.3995 17.609 13.3333 17.8509M13.3333 5.3335L17.3333 5.3335M13.3333 5.3335L13.3333 9.3335M10.6667 18.6667C10.6667 18.6667 10.1005 18.5858 7.75736 16.2427C5.41421 13.8995 5.41421 10.1005 7.75736 7.75739C8.58754 6.92721 9.60048 6.39116 10.6667 6.14925M10.6667 18.6667L6.66667 18.6668M10.6667 18.6667L10.6667 14.6668" 
          stroke={iconColor} 
          strokeWidth={strokeWidth} 
          strokeLinecap="round" 
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
